import Navbar from "@/components/unsf/Navbar"
import Footer from "@/components/unsf/Footer"
import { MediaItem } from "@/components/unsf/MediaGallery"
import { Variant } from "@/components/unsf/VariantSelector"
import ItemDetail from "@/components/storefront/ItemDetail"
import UnsfHead, { UnsfMeta } from "@/components/unsf/UnsfHead"
import type {
  UnsfNavbarProps,
  UnsfFooterProps,
} from "@/components/unsf/LegalLayout"

interface ItemDetailData {
  id: number
  name: string
  price: string
  description: string | null
  details: string | null
  shipping_information: string | null
  product_fit: number | null
  pre_sale: boolean
  internal_pre_sale: boolean
  soldout: boolean
  pre_sale_url: string | null
  release_date_long: string | null
  specifications: string[]
  sizing_info_url: string | null
}

interface Props {
  meta: UnsfMeta
  item: ItemDetailData
  medias: MediaItem[]
  variants: Variant[]
  virtual_stock: number
  store: { holiday: boolean; display_stock: boolean }
  add_to_cart_url: string
  back: { url: string; label: string }
  labels: {
    product_information: string
    size: string
    select_variant: string
    add_to_cart: string
    last_one: string
    in_stock: string
    in_stock_template: string
    out_of_stock: string
    participate_crowdfunding: string
    product_fit: string
    fit_small: string
    fit_true_to_size: string
    fit_large: string
    product_story: string
    shipping_information: string
    shipping_text: string
    details: string
    sizing_infos: string
    pre_sale: string
    pre_sale_tooltip: string | null
  }
  navbar: UnsfNavbarProps
  footer: UnsfFooterProps
  csrf_token: string
  cart: import("@/components/unsf/Cart").CartData
}

export default function Item({
  meta,
  item,
  medias,
  variants,
  virtual_stock,
  store,
  add_to_cart_url,
  back,
  labels,
  navbar,
  footer,
  csrf_token,
  cart,
}: Props) {
  const breadcrumbs = [
    { name: "UNSF Clothing", url: meta.canonical_url.replace(/\/items\/.*/, "/") },
    { name: "Store", url: meta.canonical_url.replace(/\/items\/.*/, "/store") },
    { name: item.name, url: meta.canonical_url },
  ]

  return (
    <>
      <UnsfHead meta={meta} breadcrumbs={breadcrumbs} />

      <Navbar
        isHome={false}
        logoWhite={navbar.logo_white}
        logoBlack={navbar.logo_black}
        labels={navbar.labels}
        urls={navbar.urls}
        locale={{
          current: navbar.locale.current,
          other: navbar.locale.other,
          switchUrl: navbar.locale.switch_url,
        }}
        csrfToken={csrf_token}
        cart={cart}
      />

      <ItemDetail
        item={item}
        medias={medias}
        variants={variants}
        virtualStock={virtual_stock}
        store={store}
        addToCartUrl={add_to_cart_url}
        back={back}
        labels={labels}
        breadcrumb={[
          { label: "UNSF", href: navbar.urls.root },
          { label: "Boutique", href: navbar.urls.store },
          { label: item.name },
        ]}
      />

      <Footer
        logoWhite={footer.logo_white}
        labels={footer.labels}
        urls={footer.urls}
      />
    </>
  )
}
